import React, {useEffect, useState} from 'react';
import {View, Text} from "react-native";

interface ILoadingProps {
    error: string;
    loading: boolean;

}


export const Loading = (props: ILoadingProps) => {
    const [showIndex, setShowIndex] = useState(1);
    useEffect(() => {
        const interval = setInterval((s) => {
            setShowIndex((prevNo) => {
                if (prevNo === 4) return 1;
                return prevNo + 1
            });
        }, 500);
        return function onUnmount() {
            clearInterval(interval)
        }
    }, []);
    if (props.error) return <View
        style={{flex: 1, height: '90vh', justifyContent: 'center', alignItems: 'center'}}><Text
        style={{fontSize: 25}}>{props.error}</Text></View>;
    if (!props.loading) return null;
    return <View style={{height: '90vh', justifyContent: 'center', alignItems: 'center'}}>
        <View style={{position: 'relative'}}>
            <View style={{position: 'absolute', top: -50, left: -100}}>
                <Text style={{fontSize: 50}}>Loading{Array(showIndex).join(".")}</Text>
            </View>
        </View>
    </View>
}